import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { projectAPI } from 'src/app/services/apiRoutes';
import { PaginationObject } from 'src/app/models/paginationObject';
import paginationHelper from 'src/app/helpers/pagination';
import sortHelper from 'src/app/helpers/sort';
import { SortObject } from 'src/app/models/sortObject';

@Injectable()
export class ProjectsService {
  constructor(public http: HttpClient) {}

  async getProjects(pageInfo: PaginationObject, sortObject: SortObject[] | null, query: string) {
    return this.http
      .get(
        projectAPI + paginationHelper.constructPagination(pageInfo) + sortHelper.constructSort(sortObject, true) + query
      )
      .toPromise();
  }

  public addMeInProject(identifier: string) {
    return this.http.put(projectAPI + '/' + identifier + '/add_me_in_project', {});
  }
}
